import $ from 'jquery';
import Silder from './slider';
import timerDo from './timer-do';

$.fn.timerDo = timerDo;

export function initBannerSlider() {
  if ($('.pslider').length < 1) {
    return;
  }

  // 메인 배너 슬라이드
  var bannerSlider = new Silder({
    container: '.pslider',
    slides: '.pslider__link',
    images: '.pslider__image',

    listContainer: '.pslider__list',
    listTag: '<a href="#" class="pslider__title" data-target="{slideId}">{altText}</a>',
    listActiveClass: 'pslider--active',
    listPerPage: 3,
    listPageWidth: 618,
    listWidth: 206,
    blankList: '.pslider__blank',
    isMoveByPage: true,

    startIndex: 'random',
    prevSlide: '.pslider__prev',
    nextSlide: '.pslider__next',

    pagination: true,
    pageContainer: '.pslider__paging',
    pageTag: '<a href="#" class="pslider__page" data-target="{slideId}">{altText}</a>'
  });

  if (bannerSlider.$listContainer) {
    bannerSlider.start(function () {
      $(this).timerDo(function () {
        $(this).find('.pslider__next').click();
      });

      $(this).find('.pslider__banners').show();
    });
  }
}
